import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_right",
  "use": "svg_right-usage",
  "viewBox": "0 0 7 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7 12\" id=\"svg_right\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M.473.292a.734.734 0 0 0 0 1.047L5.193 6l-4.72 4.661a.734.734 0 0 0 0 1.048c.293.289.768.289 1.06 0l5.245-5.18a.742.742 0 0 0 0-1.058L1.533.291a.757.757 0 0 0-1.06 0Z\" fill=\"#003087\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol